export const ACCOUNT_SETTINGS_DATA = {
  en: {
    accountSettingsTitle: "Account Settings",
    mode: "Dark Mode",
    profile: "Profile",
    fullName: "Full Name",
    accountSettingsSubTitle: "Manage your account settings",
    phoneNumber: "Phone Number",
    designation: "Designation",
    companyName: "Company Name",
    fullNamePlaceholder: "Enter Full Name",
    phoneNumberPlaceholder: "Enter Phone Number",
    designationPlaceholder: "Enter Designation",
    companyNamePlaceholder: "Enter Company Name",
    fullNameError: "Full Name is required",
    phoneNumberError: "Phone Number is required",
    designationError: "Designation is required",
    companyNameError: "Company Name is required",
    changeProfileText: "Change Profile",
    fileSizeError: "File size must be less than 3MB",
    cancelText: "Cancel",
    saveChangesText: "Save Changes",
    imageSuccess:'Image updated successfully.',
    userDetailsSavedSuccessfully: "Saved",
  },
  ar: {
    accountSettingsTitle: "إعدادات الحساب",
    mode: "الوضع الداكن",
    profile: "الملف الشخصي",
    fullName: "الاسم الكامل",
    accountSettingsSubTitle: "إدارة إعدادات الحساب",
    phoneNumber: "رقم الهاتف",
    designation: "المسمى الوظيفي",
    companyName: "اسم الشركة",
    fullNamePlaceholder: "الاسم الكامل",
    phoneNumberPlaceholder: "رقم الهاتف",
    designationPlaceholder: "المسمى الوظيفي",
    companyNamePlaceholder: "اسم الشركة",
    fullNameError: "الاسم الكامل مطلوب",
    phoneNumberError: "رقم الهاتف مطلوب",
    designationError: "المسمى الوظيفي مطلوب",
    companyNameError: "اسم الشركة مطلوب",
    changeProfileText: "تغيير الملف الشخصي",
    fileSizeError: "يجب أن يكون حجم الملف أقل من 3MB",
    cancelText: "إلغاء",
    saveChangesText: "حفظ التغييرات",
    imageSuccess: "تم تحديث الصورة بنجاح",
    userDetailsSavedSuccessfully: "تم الحفظ",
  },
};

export default ACCOUNT_SETTINGS_DATA;